module.exports = ".avviso-ie {\n  background: #335281;\n  color: white;\n  padding: 30px;\n  font-size: 15px;\n  margin: 0;\n  text-align: center; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/avviso-ie/avviso-ie.component.scss
// module id = ./src/app/avviso-ie/avviso-ie.component.scss
// module chunks = main